import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", {
  class: "alignment-selector__line-detail",
  style: {"width":"24px"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", {
  class: "alignment-selector__line-detail",
  style: {"width":"10px"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", {
  class: "alignment-selector__line-detail",
  style: {"width":"16px"}
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { TextAlign } from '@/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'AlignmentSelector',
  props: {
    selectedAlignment: null,
    disabled: { type: Boolean }
  },
  emits: ["alignmentSelected"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'alignmentSelected', alignment: TextAlign): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectedAlignment: TextAlign | null,
  disabled: boolean
};

const alignments: TextAlign[] = ['left', 'center', 'right']





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['alignment-selector', { 'alignment-selector--disabled': __props.disabled }])
  }, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(alignments, (alignment) => {
      return _createElementVNode("div", {
        key: alignment,
        class: _normalizeClass([
        'alignment-selector__item',
        { 'alignment-selector__item--selected': __props.selectedAlignment === alignment }
      ]),
        onClick: ($event: any) => (emits('alignmentSelected', alignment))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(['alignment-selector__detail-container', `alignment-selector__detail-container--${alignment}`])
        }, _hoisted_5, 2)
      ], 10, _hoisted_1)
    }), 64))
  ], 2))
}
}

})